(function () {
  'use strict';

  var MODAL_ID = 'ProductPopupBookingOverall';

  var STANDORT_NAMES = {
    muc: 'München',
    muenchen: 'München',
    munich: 'München',
    dus: 'Düsseldorf',
    duesseldorf: 'Düsseldorf',
    dusseldorf: 'Düsseldorf'
  };

  function waitFor(conditionFn, options) {
    options = options || {};
    var timeout = options.timeout || 10000;
    var interval = options.interval || 100;

    return new Promise(function (resolve, reject) {
      var start = Date.now();

      function tick() {
        try {
          var result = conditionFn();
          if (result) {
            resolve(result);
            return;
          }
        } catch (e) {}

        if (Date.now() - start >= timeout) {
          reject(new Error('Timeout waiting for booking deep link step'));
          return;
        }

        setTimeout(tick, interval);
      }

      tick();
    });
  }

  function getConfig() {
    return window.__bookingArztConfig || [];
  }

  function parseParams() {
    var params = new URLSearchParams(window.location.search);
    var arztSlug = params.get('arzt');

    if (!arztSlug) {
      return null;
    }

    var normalizedSlug = arztSlug.toLowerCase();
    var arzt = getConfig().find(function (entry) {
      return entry.slug === normalizedSlug;
    });

    if (!arzt) {
      console.warn('[BookingDeepLink] Kein Arzt für Slug gefunden:', arztSlug);
      return null;
    }

    var service = params.get('service') || params.get('behandlung');
    var standortParam = params.get('standort') || params.get('location');
    var standort = standortParam ? String(standortParam).toLowerCase() : '';

    if (!service || !standort) {
      console.warn('[BookingDeepLink] URL muss arzt, service und standort enthalten');
      return null;
    }

    return {
      arzt: arzt,
      service: String(service),
      standort: standort,
      locationName: STANDORT_NAMES[standort] || null
    };
  }

  function hasDeepLinkParams() {
    var params = new URLSearchParams(window.location.search);
    var arzt = params.get('arzt');
    var service = params.get('service') || params.get('behandlung');
    var standort = params.get('standort') || params.get('location');

    return !!(arzt && service && standort);
  }

  function openModal() {
    if (typeof window.openBookingModal === 'function') {
      window.openBookingModal();
      return;
    }

    var modal = document.getElementById(MODAL_ID);
    if (modal) {
      modal.classList.add('modal--is-active');
      if (typeof window.lockBookingPageScroll === 'function') {
        window.lockBookingPageScroll();
      } else {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }
    }
  }

  function getLocationId(modal, locationName) {
    var items = modal.querySelectorAll('.location-item');

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.getAttribute('data-location-name') === locationName && !item.classList.contains('no-available')) {
        return item.getAttribute('data-location-name-id');
      }
    }

    return null;
  }

  function showDeepLinkLoading(modal) {
    modal.classList.add('booking-modal--deep-link');

    var modalInner = modal.querySelector('.modal__inner') || modal;
    var overlay = modalInner.querySelector('.booking-deeplink-loading');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'booking-deeplink-loading booking-loading-overlay';
      overlay.innerHTML = '<div class="booking-loading-spinner"><div class="spinner"></div><p>Termine werden geladen...</p></div>';
      modalInner.appendChild(overlay);
    }

    overlay.style.display = 'flex';
  }

  function hideDeepLinkLoading(modal) {
    var modalInner = modal.querySelector('.modal__inner') || modal;
    var overlay = modalInner.querySelector('.booking-deeplink-loading');

    if (overlay) {
      overlay.style.display = 'none';
    }
  }

  function waitForCalendar(modal) {
    return waitFor(function () {
      var calendarStep = modal.querySelector('.date-and-time-step.showStep');
      var swiper = modal.querySelector('.swiper-container');
      var loader = modal.querySelector('.swiper-loading-shimmer-container');
      var slides = modal.querySelectorAll('.date-and-time-step .swiper-slide');

      if (!calendarStep || !swiper || swiper.style.display === 'none') {
        return null;
      }

      if (loader && loader.style.display !== 'none') {
        return null;
      }

      if (!slides.length) {
        return null;
      }

      return true;
    }, { timeout: 20000 });
  }

  function apply(options) {
    options = options || {};

    if (apply.inProgress) {
      return apply.pendingPromise || Promise.resolve(false);
    }

    var link = parseParams();

    if (!link) {
      if (hasDeepLinkParams()) {
        console.warn('[BookingDeepLink] Konfiguration unvollständig — öffne normales Buchungsmodal');
        openModal();
      }
      return Promise.resolve(false);
    }

    if (!link.locationName) {
      console.warn('[BookingDeepLink] Unbekannter standort in URL:', link.standort);
      return Promise.resolve(false);
    }

    console.log('[BookingDeepLink] Starte Deep Link (direkt zum Kalender):', link);

    apply.inProgress = true;
    openModal();

    var modal = document.getElementById(MODAL_ID);
    if (!modal) {
      apply.inProgress = false;
      return Promise.resolve(false);
    }

    showDeepLinkLoading(modal);

    apply.pendingPromise = waitFor(function () {
      var hooks = window.BookingOverallDeepLink;

      if (hooks && typeof hooks.apply === 'function') {
        return hooks;
      }

      return null;
    }, { timeout: 20000 })
      .then(function (hooks) {
        var items = modal.querySelectorAll('.location-item');

        if (!items.length) {
          return waitFor(function () {
            return modal.querySelectorAll('.location-item').length > 0 ? true : null;
          }, { timeout: 15000 }).then(function () {
            return hooks;
          });
        }

        return hooks;
      })
      .then(function (hooks) {
        var locationId = getLocationId(modal, link.locationName);

        if (!locationId) {
          console.warn('[BookingDeepLink] Standort nicht gefunden:', link.locationName);
          hideDeepLinkLoading(modal);
          return false;
        }

        var applied = hooks.apply({
          locationId: locationId,
          service: link.service,
          userId: link.arzt.clinicore_id,
          userName: link.arzt.name
        });

        return Promise.resolve(applied).then(function (success) {
          if (!success) {
            hideDeepLinkLoading(modal);
            return false;
          }

          return waitForCalendar(modal)
            .then(function () {
              hideDeepLinkLoading(modal);
              console.log('[BookingDeepLink] Kalender bereit für:', link.arzt.name);
              return true;
            })
            .catch(function () {
              hideDeepLinkLoading(modal);
              return true;
            });
        });
      })
      .then(function (success) {
        if (success) {
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'booking_deep_link_applied',
              booking_arzt: link.arzt.slug,
              booking_service: link.service,
              booking_location: link.locationName
            });
          } catch (e) {}
        }

        return success;
      })
      .catch(function (error) {
        console.error('[BookingDeepLink]', error);
        hideDeepLinkLoading(modal);
        return false;
      })
      .finally(function () {
        apply.inProgress = false;
        apply.pendingPromise = null;
      });

    return apply.pendingPromise;
  }

  function buildUrl(config) {
    config = config || {};
    var params = new URLSearchParams();

    if (config.arzt) {
      params.set('arzt', config.arzt);
    }
    if (config.service) {
      params.set('service', config.service);
    }
    if (config.standort) {
      params.set('standort', config.standort);
    }

    var base = config.base || '/';
    var query = params.toString();
    return query ? base + '?' + query : base;
  }

  window.BookingDeepLink = {
    apply: apply,
    parseParams: parseParams,
    hasDeepLinkParams: hasDeepLinkParams,
    getConfig: getConfig,
    buildUrl: buildUrl
  };
})();
